export enum CategoriaPessoaJuridica {
    Matriz = 1,
    Filial = 2,
    OrgaosEEntePublico = 3,
    UnidadeNegocio = 4,
    Grupo = 5,
  }
  
  export const CategoriaPessoaJuridicaLabel = new Map<CategoriaPessoaJuridica, string>([
    [CategoriaPessoaJuridica.Matriz, "Matriz"],
    [CategoriaPessoaJuridica.Filial, "Filial"],
    [CategoriaPessoaJuridica.OrgaosEEntePublico, "Órgãos e entes públicos"],
    [CategoriaPessoaJuridica.UnidadeNegocio, "Unidade de negócio (BU)"],
    [CategoriaPessoaJuridica.Grupo, "Grupo"],
  ]);
  